import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    // PC
    // 主页
    {
      path: '/',
      name: 'homeP',
      redirect: '/homeP',
      component: resolve=>{
        require(['@/components/pc/pages/home/HomeP.vue'],resolve)
      }
    },
    {
      path: '/homeP',
      name: 'homeP',
      component: resolve=>{
        require(['@/components/pc/pages/home/HomeP.vue'],resolve)
      }
    },
    // 街道导航
    {
      path: '/streetP',
      name: 'streetP',
      component:resolve=>{
        require(['@/components/pc/pages/home/street/StreetP.vue'],resolve)
      }
    },
    // 院校导航
    {
      path: '/academyP',
      name: 'academyP',
      component: resolve => {
        require(['@/components/pc/pages/home/academy/AcademyP.vue'], resolve)
      }
    },
    // 投资者数据库
    {
      path: '/investmentP',
      name: 'investmentP',
      component:resolve=>{
        require(['@/components/pc/pages/home/investment/InvestmentP.vue'],resolve)
      }
    },
    // 关于我们
    {
      path: '/aboutUsP',
      name: 'aboutUsP',
      component:resolve=>{
        require(['@/components/pc/pages/home/about-us/AboutUsP.vue'],resolve)
      }
    },
    // 交易所导航
    {
      path: '/exchangeP',
      name: 'exchangeP',
      component:resolve=>{
        require(['@/components/pc/pages/home/exchange/ExchangeP.vue'],resolve)
      }
    },
    // 商业计划书
    {
      path: '/prospectusP',
      name: 'prospectusP',
      component:resolve=>{
        require(['@/components/pc/pages/home/investment/prospectus/ProspectusP.vue'],resolve)
      }
    },
    //注册企业
    {
      path: '/listedP',
      name: 'listedP',
      component:resolve=>{
        require(['@/components/pc/pages/listed/ListedP.vue'],resolve)
      }
    },
    // 注册企业详情
    {
      path: '/listedDetailP',
      name: 'listedDetailP',
      component:resolve=>{
        require(['@/components/pc/pages/listed/listed-detail/ListedDetailP.vue'],resolve)
      }
    },
    //产业集群
    {
      path: '/baseP',
      name: 'baseP',
      component:resolve=>{
        require(['@/components/pc/pages/base/BaseP.vue'],resolve)
      }
    },
    // 产业集群详情
    {
      path: '/baseDetailP',
      name: 'baseDetailP',
      component:resolve=>{
        require(['@/components/pc/pages/base/base-detail/BaseDetailP.vue'],resolve)
      }
    },
    // 学术平台详情
    {
      path: '/platformDetailP',
      name: 'platformDetailP',
      component:resolve=>{
        require(['@/components/pc/pages/base/base-detail/PlatformDetailP.vue'],resolve)
      }
    },
    // 街道详情
    {
      path: '/streetDetailP',
      name: 'streetDetailP',
      component:resolve=>{
        require(['@/components/pc/pages/base/base-detail/StreetDetailP.vue'],resolve)
      }
    },
    // 孵化基地
    {
      path: '/incubatorP',
      name: 'incubatorP',
      redirect: '/incDefaultP',
      component:resolve=>{
        require(['@/components/pc/pages/incubator/IncubatorP.vue'],resolve)
      },
      children: [
        {
          path: '/incDefaultP',
          name: 'incDefaultP',
          component: resolve => {
            require(['@/components/pc/pages/incubator/inc-default-page/IncDefaultP.vue'], resolve)
          }
        },
        {
          path: '/incListP',
          name: 'incListP',
          component: resolve => {
            require(['@/components/pc/pages/incubator/inc-list-page/IncListP.vue'], resolve)
          }
        }
      ]
    },
    // 孵化基地详情
    {
      path: '/incubatorDetailP',
      name: 'incubatorDetailP',
      component:resolve=>{
        require(['@/components/pc/pages/incubator/incubator-detail/IncubatorDetailP.vue'],resolve)
      }
    },
    // 共用详情页
    {
      path: '/commonDetailP',
      name: 'commonDetailP',
      component:resolve=>{
        require(['@/components/pc/pages/common-detail/CommonDetailP.vue'],resolve)
      }
    },
    // 与投资者关系
    {
      path: '/investorP',
      name: 'investorP',
      component: resolve => {
        require(['@/components/pc/pages/investor/investorP.vue'], resolve)
      }
    },
    // 更多列表页
    {
      path: '/moreDataListP',
      name: 'moreDataListP',
      component: resolve => {
        require(['@/components/pc/pages/investor/more-data-list/MoreDataListP.vue'], resolve)
      }
    },
    // 通知公告
    {
      path: '/notificationP',
      name: 'notificationP',
      component: resolve => {
        require(['@/components/pc/pages/investor/notification/NotificationP.vue'], resolve)
      }
    },
    // 信息披露
    {
      path: '/informationP',
      name: 'informationP',
      component: resolve => {
        require(['@/components/pc/pages/investor/information/InformationP.vue'], resolve)
      }
    },
    // 投资机构
    {
      path: '/organizationP',
      name: 'organizationP',
      component: resolve => {
        require(['@/components/pc/pages/investor/organization/OrganizationP.vue'], resolve)
      }
    },
    // 企业社会责任
    {
      path: '/dutyP',
      name: 'dutyP',
      component: resolve => {
        require(['@/components/pc/pages/duty/DutyP.vue'], resolve)
      }
    },
    // 系统规则
    {
      path: '/ruleP',
      name: 'ruleP',
      component: resolve => {
        require(['@/components/pc/pages/rule/RuleP.vue'], resolve)
      }
    },
    // 协会
    {
      path: '/associationP',
      name: 'AssociationP',
      component: resolve => {
        require(['@/components/pc/pages/home/association/AssociationP.vue'], resolve)
      }
    },
    {
      path: '/associationDetailP',
      name: 'AssociationDetailP',
      component: resolve => {
        require(['@/components/pc/pages/home/association/association-detail/AssociationDetailP.vue'], resolve)
      }
    },
    // mobile
    // 首页
    {
      path: '/homeM',
      name: 'homeM',
      component: resolve=>{
        require(['@/components/mobile/pages/home/HomeM.vue'],resolve)
      }
    },
    // 投资者数据库
    {
      path: '/investmentM',
      name: 'investmentM',
      component:resolve=>{
        require(['@/components/mobile/pages/home/investment/InvestmentM.vue'],resolve)
      }
    },
    // 投递商业计划书
    {
      path: '/prospectusM',
      name: 'prospectusM',
      component:resolve=>{
        require(['@/components/mobile/pages/home/investment/prospectus/ProspectusM.vue'],resolve)
      }
    },
    {
      path: '/exchangeM',
      name: 'exchangeM',
      component:resolve=>{
        require(['@/components/mobile/pages/home/exchange/ExchangeM.vue'],resolve)
      }
    },
    // 注册企业
    {
      path: '/listedM',
      name: 'listedM',
      component: resolve=>{
        require(['@/components/mobile/pages/listed/ListedM.vue'],resolve)
      }
    },
    {
      path: '/listedDetailM',
      name: 'listedDetailM',
      component: resolve=>{
        require(['@/components/mobile/pages/listed/listed-detail/ListedDetailM.vue'],resolve)
      }
    },
    // 产业集群
    {
      path: '/baseM',
      name: 'baseM',
      component: resolve=>{
        require(['@/components/mobile/pages/base/BaseM.vue'],resolve)
      }
    },
    {
      path: '/baseDetailM',
      name: 'baseDetailM',
      component: resolve=>{
        require(['@/components/mobile/pages/base/base-detail/BaseDetailM.vue'],resolve)
      }
    },
    // 街道
    {
      path: '/streetM',
      name: 'StreetM',
      component: resolve => {
        require(['@/components/mobile/pages/street/StreetM.vue'], resolve)
      }
    },
    // 街道详情
    {
      path: '/streetDetailM',
      name: 'StreetDetailM',
      component: resolve => {
        require(['@/components/mobile/pages/street/street-detail/StreetDetailM.vue'], resolve)
      }
    },
    // 院校
    {
      path: '/academyM',
      name: 'AcademyM',
      component: resolve => {
        require(['@/components/mobile/pages/academy/AcademyM.vue'], resolve)
      }
    },
    // 院校详情
    {
      path: '/academyDetailM',
      name: 'AcademyDetailM',
      component: resolve => {
        require(['@/components/mobile/pages/academy/academy-detail/AcademyDetailM.vue'], resolve)
      }
    },
    // 孵化基地
    {
      path: '/incubatorM',
      name: 'incubatorM',
      redirect: '/incubatorDefaultM',
      // redirect: '/incubatorListM',
      component: resolve=>{
        require(['@/components/mobile/pages/incubator/IncubatorM.vue'],resolve)
      },
      children: [
        {
          path: '/incubatorDefaultM',
          name: 'IncubatorDefaultM',
          component: resolve => {
            require(['@/components/mobile/pages/incubator/incubator-default/IncubatorDefaultM.vue'], resolve)
          }
        },
        {
          path: '/incubatorListM',
          name: 'IncubatorListM',
          component: resolve => {
            require(['@/components/mobile/pages/incubator/incubator-list/IncubatorListM.vue'], resolve)
          }
        },
      ]
    },
    {
      path: '/incubatorDetailM',
      name: 'incubatorDetailM',
      component: resolve=>{
        require(['@/components/mobile/pages/incubator/incubator-detail/IncubatorDetailM.vue'],resolve)
      }
    },
    // 与投资者关系
    {
      path: '/investorM',
      name: 'InvestorM',
      component: resolve=>{
        require(['@/components/mobile/pages/investor/InvestorM.vue'],resolve)
      }
    },
    // 企业社会责任
    {
      path: '/dutyM',
      name: 'DutyM',
      component: resolve=>{
        require(['@/components/mobile/pages/duty/DutyM.vue'],resolve)
      }
    },
    {
      path: '/moreListM',
      name: 'MoreListM',
      component: resolve => {
        require(['@/components/mobile/pages/duty/MoreListM.vue'], resolve)
      }
    },
    // 系统规则
    {
      path: '/ruleM',
      name: 'RuleM',
      component: resolve=>{
        require(['@/components/mobile/pages/rule/RuleM.vue'],resolve)
      }
    },
    // 协会
    {
      path: '/associationM',
      name: 'AssociationM',
      component: resolve=>{
        require(['@/components/mobile/pages/association/AssociationM.vue'],resolve)
      }
    },
    // 协会详情
    {
      path: '/associationDetailM',
      name: 'AssociationDetailM',
      component: resolve=>{
        require(['@/components/mobile/pages/association/association-detail/AssociationDetailM.vue'],resolve)
      }
    },
    // 政策、动态公用详情页
    {
      path: '/commonDetailM',
      name: 'commonDetailM',
      component: resolve => {
        require(['@/components/mobile/pages/common-detail/CommonDetailM.vue'], resolve)
      }
    },
    // 共用列表数据页
    {
      path: '/commonMoreListM',
      name: 'CommonMoreListM',
      component: resolve => {
        require(['@/components/mobile/pages/common-detail/CommonMoreListM.vue'], resolve)
      }
    },
    // 关于我们
    {
      path: '/aboutUsM',
      name: 'aboutUsM',
      component: resolve => {
        require(['@/components/mobile/pages/home/about-us/AboutUsM.vue'], resolve)
      }
    }
  ]
})
router.beforeEach((to, form, next) => {
  let isMobile = /Android|webOS|iPhone|iPod|BlackBerry/i.test(navigator.userAgent);
  window.localStorage.setItem("isMobile", isMobile);
  let nameArr = String(to.name).split('');
  let flag = nameArr.pop()[0];
  let f_p_data = to.fullPath.split('?')[1]; // 页面参数
  if(flag === 'P') {
    if(isMobile) {
      let toPath = nameArr.join('') + 'M?' + f_p_data;
      next({path: toPath});
      return;
    } else {
      next();
    }
  } else {
    if(!isMobile) {
      let toPath = nameArr.join('') + 'P?' + f_p_data;
      next({path: toPath});
      return;
    } else {
      next();
    }
  }
})
export default router;


// WEBPACK FOOTER //
// ./src/router/index.js